// extracted by mini-css-extract-plugin
export default {"error":"ErrorLabel_error__cPfPS","errorContainer":"ErrorLabel_errorContainer__eZrVl"};